import { Typography } from "antd";
import { useEffect, useMemo, useState } from "react";
import useAuth from "../../../hooks/useAuth";
import Table, { ColumnsType } from "antd/lib/table";
import NotSet from "../../../components/NotSet";
import { Link } from "react-router-dom";
import { thousandSeparator } from "../../../helpers/numberFormat";

type IProps = {
	contentType: string;
	tableType: string;
	dataProps: any[];
};

const { Text } = Typography;

const StatisticTopListingTable: React.FC<IProps> = ({ contentType, tableType, dataProps }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [data, setData] = useState<any>([]);
	const { isFOPlus, isHQFinance } = useAuth();

	async function fetchMostViewedData() {
		setIsLoading(true);
		if (dataProps && dataProps?.length > 0) {
			setData(dataProps || []);
		}
		setIsLoading(false);
	}

	async function fetchMostSharedData() {
		setIsLoading(true);
		if (dataProps && dataProps?.length > 0) {
			setData(dataProps || []);
		}
		setIsLoading(false);
	}

	useEffect(() => {
		if (tableType === "views") {
			fetchMostViewedData();
		}
		if (tableType === "shares") {
			fetchMostSharedData();
		}
	}, [dataProps]);

	const dataSort = useMemo(() => {
		if (tableType === "views")
			return data.filter((v: any) => +v.viewCount > 0).sort((a: any, b: any) => +b.viewCount - +a.viewCount);
		if (tableType === "shares")
			return data.filter((v: any) => +v.shareCount > 0).sort((a: any, b: any) => +b.shareCount - +a.shareCount);
	}, [data, tableType]);

	const columns: ColumnsType<any> = [
		{
			title: "LISTING ID",
			key: "listingCode",
			dataIndex: "listingCode",
			width: 120,
			render: (listingCode: string, record) => {
				return (
					<Link to={"/listing/" + record.listingId}>
						{listingCode ? listingCode?.toUpperCase() : <NotSet />}
					</Link>
				);
			},
		},
		{
			title: "TITLE",
			key: "title",
			dataIndex: "title",
			width: 480,
			render(value: string) {
				return value ?? <NotSet />;
			},
		},
		{
			title: "AGENT NAME",
			dataIndex: ["user", "nickName"],
			key: "nickName",
			width: 200,
			render: (nickName: string, record) => <>{nickName ? nickName?.toUpperCase() : <NotSet />}</>,
		},
		isFOPlus || isHQFinance
			? {
					title: "OFFICE",
					dataIndex: ["office", "officeName"],
					key: "officeName",
					width: 150,
			  }
			: {},
		{
			title: tableType === "views" ? "TOTAL VIEWS" : tableType === "shares" ? "TOTAL SHARES" : "",
			key: "title",
			render: (title: string, record) => (
				<Text>
					{tableType === "views" && thousandSeparator(record.viewCount)}
					{tableType === "shares" && thousandSeparator(record.shareCount)}
				</Text>
			),
		},
	];

	return (
		<>
			<Table
				loading={isLoading}
				columns={columns}
				dataSource={dataSort}
				rowKey="listingId"
				pagination={false}
			/>
		</>
	);
};

export default StatisticTopListingTable;
